<div class="pressure-container">
    <ngx-slider *ngIf="!isStatic && !isBalance && showActions && !generatingPDF" [(value)]="sliderFramesPerSecond.value"
        [options]="sliderFramesPerSecond.options"></ngx-slider>

    <!-- <div class="map" #map>
        <div class="spinner-grow text-primary" role="status" *ngIf="loadingJson">
            <span class="sr-only">Loading...</span>
        </div>
    </div> -->
    <canvas #myCanvas id="canvas" width="{{width}}" height="{{width}}" style="width: 100%;">
        <div class="spinner-grow text-primary" role="status" *ngIf="loadingJson">
            <span class="sr-only">Loading...</span>
        </div>
    </canvas>
    <!-- <span>{{time}}</span>
    <span>{{foundAlonePoints}}</span> -->


    <ngx-slider *ngIf="!isStatic && !isBalance && showActions && !generatingPDF" [(value)]="sliderOption.value"
        [options]="sliderOption.options" (valueChange)="showPressure(sliderOption.value)"></ngx-slider>

    <div *ngIf="!isStatic && !isBalance && showActions && !generatingPDF" class="buttons-container">
        <button *ngIf="!loadingJson && jsonData && !playing" type="button" mat-raised-button color="primary"
            (click)="play()"><i class="pi pi-play"></i> </button>
        <button *ngIf="!loadingJson && jsonData && playing" type="button" mat-raised-button color="primary"
            (click)="pause()"><i class="pi pi-pause"></i> </button>

        <button *ngIf="!isStatic && !isBalance && showActions && !generatingPDF" type="button" mat-raised-button
            class="pdf-special-button" (click)="exportPDF()">
            <i class="pi pi-file-pdf"></i> </button>
    </div>
</div>